module.exports = __webpack_public_path__ + "static/media/jcb.7857e3dc.svg";